import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import cs from 'classnames';

import ApplicationCardMini from 'components/Workspaces/components/ApplicationCardMini/ApplicationCardMini';

import ApplicationsService from 'features/applications/applicationsService';
import { generateParams } from 'features/filters/filtersSlice';

import { useInfiniteScrollPagination } from 'hooks/useInfiniteScrollPagination';

import { Application, ApplicationsList } from 'types/applications';
import { Filters } from 'types/filters';

import styles from './JobApplicationsView.module.scss';

interface JobApplicationsViewProps {
  jobId: string | null;
  isEmpty?: boolean;
}

const JobApplicationsView: FC<JobApplicationsViewProps> = ({
  jobId,
  isEmpty
}: JobApplicationsViewProps) => {
  const { t } = useTranslation();

  const loadItems = useCallback(
    async (filters: Filters) => {
      if (!jobId || isEmpty) {
        return;
      }

      const params = generateParams({ ...filters, jobIds: [jobId] });
      return await ApplicationsService.getApplications(params);
    },
    [jobId, isEmpty]
  );

  const { lastElementRef, data, isLoading } = useInfiniteScrollPagination<
    ApplicationsList,
    Application
  >({
    errorMessage: t('error.message.failedFetchApplications'),
    loadItems
  });

  return (
    <section
      className={cs(styles.container, 'applications-view-sidebar-container')}
    >
      {data.map((application, index) => {
        const isLastElement = index === data.length - 1;

        return (
          <div ref={isLastElement ? lastElementRef : null}>
            <ApplicationCardMini
              application={application}
              key={application.id}
            />
          </div>
        );
      })}
      {isLoading && t('common.loading')}
    </section>
  );
};

export default JobApplicationsView;
